import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router-dom';
import { CreditCardIcon, HomeIcon, UserIcon, UsersIcon } from '../icons';
import LiabilitiesSummaryCallout from '../parent/LiabilitiesSummaryCallout';

interface NavItem {
  labelKey: string;
  icon: React.ReactNode;
  path: string;
  matchPattern: string;
}

const NAV_ITEMS: NavItem[] = [
  { labelKey: 'sidebar.start',       icon: <HomeIcon size={18} />,       path: '/parent/home',        matchPattern: '/parent/home' },
  { labelKey: 'sidebar.payments',    icon: <CreditCardIcon size={18} />, path: '/parent/payments',    matchPattern: '/parent/payments/*' },
  { labelKey: 'sidebar.collections', icon: <UsersIcon size={18} />,      path: '/parent/collections', matchPattern: '/parent/collections/*' },
  { labelKey: 'sidebar.children',    icon: <UserIcon size={18} />,       path: '/parent/children',    matchPattern: '/parent/children/*' },
];

export default function ParentSidebar() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const matchHome        = useMatch('/parent/home');
  const matchPayments    = useMatch('/parent/payments/*');
  const matchCollections = useMatch('/parent/collections/*');
  const matchChildren    = useMatch('/parent/children/*');

  const activeMatches = [matchHome, matchPayments, matchCollections, matchChildren];

  return (
    <Box
      component="nav"
      sx={(theme) => ({
        width: 220,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        p: 2,
        backgroundColor: theme.app.card,
        borderRight: `1px solid ${theme.app.borderSubtle}`,
      })}
    >
      {NAV_ITEMS.map((item, index) => {
        const active = Boolean(activeMatches[index]);
        return (
          <Box
            key={item.path}
            onClick={() => navigate(item.path)}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              cursor: 'pointer',
              backgroundColor: active ? theme.app.accentSurface : 'transparent',
              color: active ? theme.app.foreground : theme.app.mutedForeground,
              '&:hover': {
                backgroundColor: active ? theme.app.accentSurface : theme.app.secondary,
              },
            })}
          >
            {item.icon}
            <Typography variant="body2" sx={{ fontWeight: active ? 600 : 400, color: 'inherit' }}>
              {t(item.labelKey)}
            </Typography>
          </Box>
        );
      })}

      <LiabilitiesSummaryCallout />
    </Box>
  );
}
